// extracted by mini-css-extract-plugin
export default {"AccessRestrictionText":"AccessRestrictionText_AccessRestrictionText__1CxyN","Label":"AccessRestrictionText_Label__AqwRV","Description":"AccessRestrictionText_Description__ZXKUW"};